<template>
  <button
    :class="buttonClasses"
    :type="type"
  >
    <slot />
  </button>
</template>

<script setup>
import { computed } from 'vue';

const buttonVariants = {
  primary: [
    'rounded-[6px]',
    'border',
    'border-producer-button-primary',
    'bg-producer-button-primary',
    'text-white',
    'hover:border-producer-button-primaryHover',
    'hover:bg-producer-button-primaryHover',
    'active:border-producer-button-primaryActive',
    'active:bg-producer-button-primaryActive',
    'disabled:border-producer-button-primaryDisabled',
    'disabled:bg-producer-button-primaryDisabled',
    'disabled:text-producer-button-primaryDisabledText',
  ].join('\n'),
  secondary: [
    'rounded-[6px]',
    'border',
    'border-producer-button-secondary',
    'bg-producer-button-secondarySurface',
    'text-producer-button-secondary',
    'hover:border-producer-button-secondaryHover',
    'hover:text-producer-button-secondaryHover',
    'active:border-producer-button-secondaryActive',
    'active:text-producer-button-secondaryActive',
    'disabled:border-producer-button-secondaryDisabled',
    'disabled:text-producer-button-secondaryDisabledText',
  ].join('\n'),
  tertiary: [
    'border-0',
    'bg-transparent',
    'p-0',
    'text-white',
    'hover:text-producer-button-secondaryHover',
    'active:text-producer-button-secondaryActive',
    'disabled:text-producer-button-secondaryDisabled',
  ].join('\n'),
  primaryDanger: [
    'rounded-[6px]',
    'border',
    'border-producer-button-danger',
    'bg-producer-button-danger',
    'text-white',
    'hover:border-producer-button-dangerHover',
    'hover:bg-producer-button-dangerHover',
    'active:border-producer-button-dangerActive',
    'active:bg-producer-button-dangerActive',
  ].join('\n'),
  secondaryDanger: [
    'rounded-[6px]',
    'border',
    'border-white',
    'bg-producer-button-secondarySurface',
    'text-white',
    'hover:border-[#FF766D]',
    'active:border-producer-button-dangerActive',
    'active:bg-producer-button-dangerActive',
  ].join('\n'),
};

const props = defineProps({
  variant: {
    type: String,
    default: 'primary',
  },
  type: {
    type: String,
    default: 'button',
  },
});

const buttonClasses = computed(() => [
  'inline-flex items-center justify-center px-[15px] py-[10px] text-[14px] font-bold font-barlow not-italic cursor-pointer',
  buttonVariants[props.variant] || buttonVariants.primary,
]);
</script>
